import BaseCachedDataService from '@/core/services/cachedData/BaseCachedDataService'
import { EntityListData } from '@/types/entities'
import { DEFAULT_ENTITIES_DATA } from '@/enum/defaultEntitiesData'
import { entitiesApi } from '@/api/entitiesApi'
class EntitiesDataService extends BaseCachedDataService<EntityListData> {
    constructor () {
        super(DEFAULT_ENTITIES_DATA)
    }

    async loadData () {
        const res = await entitiesApi.getList()

        if (!res) {
            return this.data = DEFAULT_ENTITIES_DATA
        }

        return this.data = { ...res }
    }
}

export default new EntitiesDataService()
